import { useNavigate } from "react-router-dom";

import ConfirmationQuestion from "../../../components/Questions/ConfirmationQuestion";
import { ABOUT_ROUTES, PATHS } from "../../../config/routeConfig";
import { useVulnerabilityContext } from "../../../context/vulnerability/useVulnerabilityContext";
import { ConfirmationAnswer } from "../../../context/vulnerability/VulnerabilityContext";
import { questionContent } from "../questions";

const Hearing: React.FC = () => {
  const { answers, setAnswers } = useVulnerabilityContext();
  const navigate = useNavigate();

  const onChange = (answer: ConfirmationAnswer) => {
    setAnswers({
      ...answers,
      hearing: answer,
    });
  };

  const onContinue = () => {
    navigate(`/${PATHS.About}/${ABOUT_ROUTES.Age}`);
  };

  return (
    <ConfirmationQuestion
      onChange={onChange}
      value={answers.hearing}
      onContinue={onContinue}
      step={questionContent.hearing.step}
      title={questionContent.hearing.title}
      subTitle={questionContent.hearing.subTitle}
      whyWeWantTexts={questionContent.hearing.whyWeWantTextsCustomer}
    />
  );
};

export default Hearing;
